/* @ngInject */
function ProfilePersonalDataController (
  $scope,
  $rootScope,
  $q,
  $state,
  $translate,
  $interval,
  $timeout,
  $window,
  Utils,
  NewAssetService,
  ToastService,
  ValidationService,
  UdsModalService,
  UploadService,
  LanguageService,
  UserService,
  StrongPasswordService,
  BackendErrorParserService
) {
  const getCropImageDialogController = () => $q.when(import('../../../core/dialogs/crop-image/crop-image-dialog.controller'))

  $scope.alerts = {
    showErrorMsgRestorePass: false,
    showErrorMsgUpdatePass: false,
    errorMsgRestorePass: ''
  }

  $scope.flags = {
    uploadingImage: false,
    userUpdateSuccessToast: false,
    passwordAlreadyUsedError: false
  }
  $scope.form = {
    name: '',
    email: '',
    profileImageId: ''
  }

  $scope.passwordForm = {
    password: '',
    newPassword: '',
    newPasswordRepeat: ''
  }

  $scope.errors = {
    name: false,
    email: false
  }

  $scope.languages = [
    {
      label: 'English',
      value: 'en-US'
    },
    {
      label: 'Português',
      value: 'pt-BR'
    },
    {
      label: 'Español',
      value: 'es-ES'
    }
  ]

  $scope.profileImageUrl = null
  $scope.isEditingPersonalData = false
  $scope.isEditingPassword = false
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId

  $scope.passwordRules = {
    eight: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  }

  $scope.passwordStrength = 'NONE'
  $scope.strongPasswordEnabled = false

  const api = {
    getCropImageDialogController,
    _userUpdateSuccess,
    _userUpdateError,
    _selectPreferredLanguage,
    _searchLanguageInArray,
    _determinePreferredLanguage,
    _getProfileImageUrl
  }
  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUser().then(oUser => {
      $scope.form.name = oUser.name
      $scope.form.email = oUser.email
      $scope.form.profileImageId = oUser.profileImageId
      $scope.profileImageUrl = api._getProfileImageUrl()
    })

    $rootScope.getCompanyConfigurations().then(companyConfigurations => {
      $scope.strongPasswordEnabled = Boolean(companyConfigurations?.ENABLE_STRONG_PASSWORD_ACCESS)
    })

    api._selectPreferredLanguage()
  }

  function objShallowEquals (obj1, obj2) {
    var allKeys = Object.keys(obj1).concat(Object.keys(obj2))
    var key
    for (var i = 0; i < allKeys.length; i++) {
      key = allKeys[i]
      if (key in obj1 && key in obj2 && obj1[key] !== obj2[key]) {
        return false
      }
    }
    return true
  }

  function checkFieldNotEmpty (sValue) {
    return sValue && sValue.trim()
  }

  function validateFormData () {
    $scope.errors.email = !ValidationService.validateEmail($scope.form.email)
    $scope.errors.name = !checkFieldNotEmpty($scope.form.name)

    return !$scope.errors.email && !$scope.errors.name
  }

  $scope.handleAvatarPress = function (oAvatar) {
    $scope.selectedAvatar = oAvatar
  }

  $scope.onInputChange = event => {
    const inputValue = event.detail.value
    const inputId = event.target.id

    $scope.form[inputId] = inputValue

    $scope.isEditingPersonalData = inputValue !== $rootScope.oUser.name
  }

  $scope.startEditPassword = () => {
    $scope.isEditingPassword = true
  }

  $scope.cancelEditPassword = () => {
    $scope.passwordForm = {
      password: '',
      newPassword: '',
      newPasswordRepeat: ''
    }

    $scope.isEditingPassword = false
    $scope.alerts.showErrorMsgRestorePass = false
    $scope.alerts.showErrorMsgUpdatePass = false
  }

  $scope.getInitials = name => {
    if (name) {
      let output = ''
      let i = 0
      const str = name.split(' ')
      const len = str.length > 2 ? 2 : str.length
      for (i; i < len; i++) if (str[i] !== '') output += str[i][0]
      return output.toUpperCase()
    }

    return null
  }

  $scope.onInputChangePassword = event => {
    const inputValue = event.detail.value
    const inputId = event.target.id

    $scope.passwordForm[inputId] = inputValue

    if (inputId === 'newPassword' && $scope.strongPasswordEnabled) {
      $scope.passwordStrength = StrongPasswordService.verifyPasswordStrength($scope.passwordForm[inputId], $scope.passwordRules)
    }
  }

  $scope.showPasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.profile-info-container .strong-password-tooltip').removeClass('hidden-tooltip')
    }
  }

  $scope.hidePasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.profile-info-container .strong-password-tooltip').addClass('hidden-tooltip')
    }
  }

  $scope.isPasswordButtonDisabled = function () {
    const inputsEmpty = !$scope.passwordForm.password || !$scope.passwordForm.newPassword || !$scope.passwordForm.newPasswordRepeat
    let passwordRulesNotChecked = false
    if ($scope.strongPasswordEnabled) {
      passwordRulesNotChecked = $scope.passwordStrength !== 'FIVE'
    }

    return inputsEmpty || passwordRulesNotChecked
  }

  $scope.updatePassword = () => {
    if ($scope.passwordForm.newPassword !== $scope.passwordForm.newPasswordRepeat) {
      $scope.alerts.showErrorMsgRestorePass = true
      $scope.alerts.errorMsgRestorePass = $translate.instant('passwordsDontMatchMsg')
      return false
    }

    $scope.flags.userUpdateSuccessToast = false
    $scope.flags.passwordAlreadyUsedError = false

    UserService.updateUserPassword({
      oldPassword: $scope.passwordForm.password,
      password: $scope.passwordForm.newPassword,
      user: $rootScope.oUser
    })
      .then(result => {
        api._userUpdateSuccess(result, true)
      })
      .catch(error => {
        if (BackendErrorParserService.passwordAlreadyUsed(error)) {
          $scope.flags.passwordAlreadyUsedError = true
        } else if (error.data.code === 'AUTHORIZATION_ERROR') {
          $scope.alerts.showErrorMsgUpdatePass = true
        }
      })
  }

  $scope.cancelEditPersonalData = function () {
    $scope.form.name = $rootScope.oUser.name
    $scope.form.email = $rootScope.oUser.email
    $scope.isEditingPersonalData = false
  }

  // return true if there is some change in the input data
  $scope.enableSaveButton = function () {
    if (!$rootScope.oUser || $scope.form) {
      return false
    }
    return objShallowEquals($scope.form, $rootScope.oUser)
  }

  $scope.updateUser = function (oUser) {
    if (!validateFormData()) {
      return
    }
    var oUpdateUser = {
      id: oUser.id,
      name: $scope.form.name || oUser.name,
      profileImageId: $scope.form.profileImageId
    }

    if ($scope.croppedImageId) {
      oUpdateUser.profileImageId = $scope.croppedImageId
    }

    $scope.flags.userUpdateSuccessToast = false
    UserService.updateUser(oUpdateUser, api._userUpdateSuccess, api._userUpdateError)
  }

  function _userUpdateSuccess (data, password) {
    $rootScope.oUser = data
    $scope.form.profileImageId = data.profileImageId || $scope.form.profileImageId
    $scope.profileImageUrl = api._getProfileImageUrl()
    $scope.croppedImage = ''
    $scope.isEditingPersonalData = false
    $scope.flags.uploadingImage = false

    if (password) {
      $scope.isEditingPassword = false
    }

    $scope.flags.userUpdateSuccessToast = true

    const interval = $interval(() => {
      NewAssetService.checkAssetHasThumb($scope.form.profileImageId, 'LOW').then((hasThumb) => {
        if (!hasThumb) {
          return
        }
        $interval.cancel(interval)

        $timeout(() => {
          $scope.profileImageUrl = api._getProfileImageUrl()
        })
      })
    }, 8000)
  }

  function _userUpdateError () {
    ToastService.defaultErrorToast()
  }

  $scope.profileImageFile = ''
  $scope.profileImage = ''

  $scope.setFiles = function (file) {
    if (!file) {
      return
    }

    $scope.flags.uploadingImage = true

    const reader = new FileReader()
    reader.onload = function (event) {
      $scope.$apply(function ($scope) {
        $scope.profileImage = event.target.result
        api.getCropImageDialogController().then(({ CropImageDialogController }) => {
          const modal = UdsModalService.createModal({
            controller: CropImageDialogController,
            modalName: 'cropImageDialog',
            data: {
              image: $scope.profileImage
            },
            onClose: (croppedImage) => {
              if (croppedImage) {
                $scope.croppedImage = croppedImage
                $scope.urlToFile(croppedImage, $scope.profileImageFile.name, $scope.profileImageFile.type)
                  .then(function (file) {
                    UploadService.uploadToS3(file)
                      .then((uploadedFile) => {
                        $scope.croppedImageId = uploadedFile.id
                        $scope.updateUser($scope.oUser)
                      })
                  })
              }
            }
          })
          modal.open()
        })
      })
    }
    reader.readAsDataURL(file)
  }

  $scope.urlToFile = function (url, filename, mimeType) {
    return Utils.urlToFile(url, filename, mimeType)
  }

  function _getProfileImageUrl () {
    if ($scope.form.profileImageId) {
      const updated = new Date().toISOString()
      return UserService.getUserProfileImage($rootScope.oUser.id, updated)
    }
  }

  $scope.removeProfileImage = function () {
    $rootScope.oUser.profileImageId = null
    $scope.form.profileImageId = null
    $scope.croppedImageId = null
    $scope.croppedImage = ''

    $scope.updateUser($rootScope.oUser)
  }

  $scope.languageSelectChange = function (event) {
    const oLanguage = event.detail
    if ($scope._preferredLanguage !== oLanguage.value) {
      $scope._preferredLanguage = oLanguage.value
      $scope.oSelectedLanguage = oLanguage
      UserService.updateUserLocale($scope._preferredLanguage).then(() => {
        LanguageService.setLocaleLanguage($scope._preferredLanguage)
        api._determinePreferredLanguage()
      })
    }
  }

  function _selectPreferredLanguage () {
    var lang = LanguageService.getLanguage()

    api._searchLanguageInArray(lang)

    // if user language is not present in our array, we use en-US
    if (!$scope.oSelectedLanguage) {
      api._searchLanguageInArray('en-US')
    }

    api._determinePreferredLanguage()
  }

  function _searchLanguageInArray (lang) {
    for (var i = 0, len = $scope.languages.length; i < len; i++) {
      $scope.languages[i].active = false
      if ($scope.languages[i].value === lang) {
        $scope.oSelectedLanguage = $scope.languages[i]
        $scope._preferredLanguage = lang
        $scope.languages[i].active = true
        return
      }
    }
  }

  function _determinePreferredLanguage () {
    if ($translate.use() !== $scope._preferredLanguage) {
      $window.location.reload()
    }
  }
}

export { ProfilePersonalDataController }
